module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER ONE")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("RINCE")]), _vm._v(" R"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("AOUL")]), _vm._v(" M"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ERTIER")]), _vm._v(" B"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ERGERET")]), _vm._v(" D’A"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("RILLAC")])]), _vm._v(" levered his tall, ripcord-strong body from the car, and strode across the cobblestone courtyard of the seventeenth-century Swiss château nestled in the forest overlooking Lake Neuchatel.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Despite the lateness of the hour, the early July night felt warm and balmy. Perfect weather for him and his friends to enjoy a relaxing climb in Zermatt over the weekend.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Intent on reaching his newly modernized apartments, a surprise from his mother he could have done without while he’d been away climbing in the Himalayas at the end of spring, he didn’t notice a figure had stepped from the shadows of the giant chestnut tree until he heard his name called.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He paused mid-stride and spun around. “Father?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I didn’t mean to startle you, my boy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Raoul shook his head and walked toward him. “Why on earth aren’t you in bed?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ve been waiting for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So I gather. Philippe just got back from Paris this evening. We’ve been discussing a weekend climb of the Matterhorn’s North Face. I’m afraid we lost track of the time.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In the moonlight, Henri Mertier’s gaze took in the handsome features of his only child, whose complexion had been darkened to teak by the elements on Everest.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He had nothing but praise for his devoted, hardworking, thirty-four-year-old son who not only was a brilliant banker and businessman in his own right, but possessed all the qualities a father could pray for in his offspring.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Temperate in most things, his son had a passion for climbing when he could get away, and he always handled his relationships with women in a discreet manner.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In truth, Henri was tremendously proud of Raoul. That was why a terrible sadness washed over him when he considered what had to be said now. He knew it was the last news his son wanted to hear.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Almost the same height as Raoul’s six-foot-two physique, he put a detaining hand on his shoulder. “Could we talk inside?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Something important was on his father’s mind. “Of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Raoul fell in step with his parent as they approached the main entrance to the château. He opened the heavy door, with the D’Arillac coat of arms emblazoned in stained glass, and ushered his father through the great hallway to the library.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Let’s have a drink, shall we? I feel the need of one.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The odd inflection in his tone caused Raoul to study his father’s sober expression which couldn’t be hidden by his trimmed brown mustache and beard. Only wings of silver at the temples indicated his seventy years of age.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The two men faced each other in front of the hearth with its ancient glazed tiles. Raoul stared at the wonderful man who’d always been his role model. The pale blue eyes held a mixture of sadness and anxiety.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Unsettled by the look, Raoul decided he needed sustenance after all and poured himself what his father was drinking.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You obviously have something serious to discuss. What is so urgent you couldn’t wait until tomorrow to tell me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His father shook his head. His hands were clasped in front of him. He rubbed his thumbs together in an attitude of reflection.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re familiar with the phrase, ‘God’s errand’?”")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Raoul didn’t move a muscle, but something unpleasant twisted in his gut—some premonition of dread. He’d experienced it on several occasions climbing in the Alps during army maneuvers. The sudden crack of sound—then avalanche. Lines darkened his features.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Say what you have to say, Father,” Raoul said with an uncustomary show of impatience. His parent’s comment had begun to alarm him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This concerns you and the Princess Sophie.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A pregnant silence invaded the booklined room with its ornate hand-carved furniture and inlaid floors. Raoul felt as if someone had put a fist to his abdomen, dead center. He ran long, tanned fingers through his dark blond hair, a trait passed down from his mother.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I thought we had an understanding that until I turned thirty-six she was a closed subject.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m afraid her father opened it when I received a call from him earlier this evening. He feels Sophie has reached the age where it has become an embarrassment for her to still be single. It seems he insists that the date of your wedding be moved up.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Henri’s words extinguished any light coming from his son’s piercing blue eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How soon?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After a tension-filled pause, “Two months.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The wineglass slipped from Raoul’s fingers and shattered against the parquetry. All color drained from his face, leaving his lips whitened. He stood there clenching and unclenching his fists.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Henri’s heart went out to Raoul. If anyone understood how his son felt, Henri did. Thirty-five years ago he’d married Raoul’s mother, Princess Louise de Bergeret. They had been betrothed from infancy. Fortunately there’d been an initial attraction on both sides and their marriage grew into a love match.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But, lovely as Sophie was, he knew the fire wasn’t there for her on Raoul’s part. Though he’d had ample opportunity over the years, his son had never sought her company.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m sorry the news is so distressing to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Raoul ran trembling hands through his hair one more time. “I’ve got to be by myself for a while, Father. Excuse me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He slipped out the doors of the family château and climbed into the forest beyond the estate. He broke into a run as he left the gentler slopes and made his way through the pines clinging to the steeper hillsides overlooking the lake.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("By the time he’d reached his destination, his breath was spent. He flung his body facedown into the bed of wild narcissus and gave way to his grief. Time had no meaning as pain continued to rack his body.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Much later, when he rose to his feet on unsteady legs, the stars had faded from their velvet backdrop.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As a pale yellow dawn filled the sky, he let himself back inside his apartment.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gripping his cellphone with a hand still redolent of narcissus, he rang Philippe.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Raoul—” he answered in a gravelly voice. “What time is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Five-thirty. Can you talk?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But of course,” his voice came back, much stronger than before. “You want me to come there?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No. Meet me at the pier. We’ll take a ride.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll join you in ten minutes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A half-hour later Raoul cut the motor of the speedboat. They were far enough away from shore to ensure total privacy. Without preamble he told Philippe about the bombshell his father had just dropped on him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mon Dieu")]), _vm._v("— I thought it was several years away yet.” The two men faced each other. Philippe clamped a hand ")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("on Raoul’s shoulder. “You don’t have to go through with it.”")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s true,” Raoul muttered. “I can be the only Arillac who ever shrank from his responsibilities in five hundred years.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It isn’t fair that a man be born with that kind of a burden. Is it written in stone you must marry the Princess?” When there was no answer forthcoming, Philippe removed his hand. “Forget I said anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Raoul’s eyes narrowed. “You think I haven’t asked myself that question at least once a day since my teens? I prayed that if I put things off long enough Sophie would experience a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("coup de foudre")]), _vm._v(" with someone else by now.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Philippe grimaced. “Ever since I’ve known you, I’ve hoped "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v(" would fall for a woman you couldn’t live without. But it never happened. Probably because you knew what was expected of you and wouldn’t allow yourself to get too involved.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Letting out the breath he’d been holding, Raoul said, “I don’t honestly know. The truth is, no woman has ever attracted me so much that I could feel my duty being tested.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why couldn’t you have had an ambitious brother?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They eyed each other soulfully. “It didn’t happen, Philippe.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His friend shook his head. “How many times have you been with her in the last year, aside from your formal engagement?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That was it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Unbelievable!” Philippe smacked his forehead. “And how many times before that?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You already know. Half a dozen maybe, since our teens.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And you were never alone with her! That’s no foundation for any kind of marriage.”")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“By the sound of that, I assume you’ve decided to take my advice and go after Kellie.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Philippe nodded. “I don’t see I have a choice. She’s become my whole world.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Philippe had confessed to Raoul that last month he’d fallen hard for a woman staying at his parents’ estate near Paris. Raoul knew his best friend had been enamoured of several women in the past, but evidently this one, Kellie, was different.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do you have any idea how lucky you are to feel that kind of desire and know it’s reciprocated?” Raoul bit out fiercely. “If you have "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _vm._v(" going for you, you can make the rest work.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ve never wanted a woman so much in my life,” he admitted in a haunted whisper. “However, this conversation isn’t about me. Raoul— I have an idea. Why don’t you ask Sophie to join us in Zermatt?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What are you talking about?” he demanded incredulously.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You two need time together away from your families and protocol. Ask her to come to your chalet. We’ll all take the cable car to Schwartzsee together. A two-hour hike to the Berghaus shouldn’t be too strenuous for her. We could do a less ambitious climb to the summit from the Hornli Ridge. If she doesn’t want to climb from there you cou—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What do you mean ‘if’?” Raoul cut in. “She’d be terrified at the thought.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("“That’s the whole point, Raoul. If she has any blood running through her veins, it should put the fear in her to consider marrying a total stranger whose passions she could never understand. The rest of us will go on to the top and leave you two alone. Reserve a double room at the hut. It should terrify her even more to discover that she’s marrying a man who’s not attracted to her in any way—who has no ")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("desire to bed her when given the opportunity. You follow me?")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Twelve hours of getting to know the real you will make her realize that neither of you has a damn thing in common. Let her see beneath the veneer to the flesh and blood man who will always be indifferent to her.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Raoul had been listening to his friend. “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mon Dieu")]), _vm._v("—if I thought for one moment I could get her to call off our betrothal…”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then you could marry the woman you want? "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("If")]), _vm._v(" she came along?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The question reverberated in his head. “I don’t know.” His voice shook. “But it’s worth finding out, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("mon ami")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As Philippe’s suggestion took hold, the first ray of hope filled Raoul’s being with such powerful intensity he leaped to his feet in reaction, almost dumping them both in the calm blue water.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Mademoiselle?”")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("While the six girls who boarded during the summer were impatiently waiting for her to finish passing out the afternoon mail, Lee Gresham looked over her shoulder at the maid. “Yes, Bianca?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The Princess Sophie de Ramblet is on the phone for you. It’s urgent. Madame Simoness said you could take the call in her private office.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll be right there.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Afraid she knew the reason why her best friend insisted she come to the phone, Lee told the girls they could go out on the grounds to relax, then hurried from the foyer of Pensionnat Beau Lac to the headmistress’s bureau.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Darting across the Aubusson rug, she reached for the receiver. Out of breath she asked softly, “Sophie?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thank heaven you answered.” Her friend sounded beside herself.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Your parents didn’t find out about Luciano, did they?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No— This is much worse.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What’s wrong? Are you alone? Can you talk?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, but only for a minute,” she said in hushed tones. “Mother just left my room. She told me Daddy’s upset because I’m not married yet. Apparently he phoned Henri Mertier last night and the matter has been settled. My wedding to Raoul has been brought forward to two months from now!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What?” Lee was aghast. “Have you told Luciano?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No. Mother was still in here with me when Raoul phoned from Neuchatel. H-he asked me to join him at his chalet in Zermatt on Thursday so we could get better acquainted over the weekend.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Better acquainted—” Lee blurted. “Don’t you mean "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("introduced?")]), _vm._v("” Her cheeks went hot. “I’m sorry, Sophie, but this whole thing is so archaic, I can’t understand it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do you honestly think I feel any differently?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lee bit her lip. “No, of course not. When we boarded together here at Beau Lac years ago, it’s ridiculous to think how much I envied you for being a princess. Your betrothal to Raoul sounded like something right out of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sleeping Beauty")]), _vm._v(". I just never dreamed the fairy tale would end up a nightmare.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s exactly what it is! I don’t dare tell Luciano until I can see him in person and explain what’s happened.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How are you going to arrange that? With your marriage imminent, you won’t have a moment to yourself.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This is where you come in, Lee. I’ve got a plan. I’ve already arranged for Madame Simoness to give you the time off…”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("Naturally. Sophie’s parents donated a fortune to the prestigious boarding school in Nyon on Lake Geneva. They were wonderful people who treated Lee like family. Lee ")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("was eaten up by guilt because they had no idea how many times she’d helped Sophie and Luciano get together.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You want me to go to Zermatt with you,” she said in a wooden voice. It was a statement, not a question.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes. We’ll take the train to Visp, where I’ll meet Luciano. You’ll go to Zermatt from there on the train and make my excuses to Raoul in person.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lee tried to swallow, but her mouth had gone dry. “I’d do just about anything for you, Sophie. But to lie to his face—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It won’t be a lie. I’m already feeling ill. Please, just listen. To avoid the press, he’s sending one of his friends named Philippe Didier to pick me up in front of the station and drive me to his chalet. The man will be holding a sign that says ‘Miami’ so people will think he’s waiting for an American tourist.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But his friend will see right away I’m not "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you!")]), _vm._v("” Lee’s panic was bordering on hysteria.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“When you inform him you’re there in my place to speak to the Prince, he won’t question it. After you reach the chalet, you’ll tell Raoul I became nauseous on the train and took the next one back to Geneva.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No. There’s one more thing I need you to do for me. It’s the last thing I’ll ever ask of you, I promise.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("How many times had Lee heard that before?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Knowing this was Sophie, the girl who in the past had got into more trouble than any other boarder at the school, Lee had the distinct impression she wasn’t going to like what her friend was about to suggest. The back of her neck started to prickle.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("By the time Sophie had finished explaining her plan, perspiration had broken out on Lee’s body. “You actually "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("want")]), _vm._v(" me to come on to him?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("“Yes. Please do it for me! You’ve seen pictures of him ")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("and know how attractive he is; it won’t be so hard. If my own best friend can tempt him to spend the weekend with her then I’ll go to my parents and tell them I refuse to marry a man who can’t even be faithful to me eight weeks before the wedding!")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If they want proof, you’ll be able to provide it. My parents love and trust you like a daughter. To hear the truth from your lips will appall them, and Daddy will call off the wedding. It "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("has")]), _vm._v(" to be my father who calls it off, Lee.” Her voice trembled. “It’s the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("only")]), _vm._v(" legitimate way the betrothal can be broken. After I’ve gone through a suitable period of grief, I’ll introduce them to Luciano.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sophie—you haven’t thought this through. Raoul will call the château to find out your condition and discover you’re not there!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not if you give him my cellphone number. Then it won’t matter where I am. I’ll think of something to tell my parents so it won’t alarm them if he does call Geneva to check up on me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("By now Lee was shaking, because it was impossible to say no to Sophie. “And what am "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I")]), _vm._v(" supposed to do if His Royal Highness decides he wants to enjoy a weekend affair with me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Knowing you, you’ll think of a gracious way to get out of it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You mean I’m to blow hot, then cold?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Exactly.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What if he’s not a gentleman?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("“Then I need to find that out too! I’m sure you’ll know how to handle him. You weren’t the most brilliant girl in school for nothing! I’ll reserve a room for you at the Belle-Vue in Zermatt. I’m sure you could use a few days’ vacation. Who knows? While you’re walking around, you might even meet a man who’ll help you put the past away. ")]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("It will give us a lot to talk about on Sunday when I join you for the return trip to Geneva.”")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lee shook her head in despair. “I don’t think I can go through with this, Sophie.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But you must! There’s only one man I want to marry, and—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("oh, la la")]), _vm._v(", someone’s coming. I have to hang up now. A car will be waiting for you outside the school at ten on Thursday morning to take you to the train station. We’ll meet on board. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Á bientôt, ma chére copine.")]), _vm._v("”")])])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page21"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5297cc76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426881688_ch02.vue
// module id = 75
// module chunks = 0